/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SessionItem } from '../../models/session-item';

export interface AuthSessions$Json$Params {
}

export function authSessions$Json(http: HttpClient, rootUrl: string, params?: AuthSessions$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SessionItem>>> {
  const rb = new RequestBuilder(rootUrl, authSessions$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SessionItem>>;
    })
  );
}

authSessions$Json.PATH = '/api/v1/auth/sessions';
